import contactsApi from "./contacts-api";


let architectsApi = {
    ...contactsApi('architects', ['phones','rt','addresses','labels', 'files', 'images', 'contact_people:id,name,email,type,cpf,company_id', 'contact_people.phones', 'contact_companies:id,name,email,type,cpf,company_id', 'contact_companies.phones', 'extraInfos.options', 'extraInfoValues', 'offices', 'offices.relatedLabels'])
}

export default architectsApi